enum CerberActionNames {
  CAPTCHA_GET = 'captchaGet',
  CAPTCHA_VERIFY = 'captchaVerify',
}

export default CerberActionNames;
